import { useMemo } from 'react';
import { environmentService } from '../services';
import { useFetch } from './useFetch';
import { useRoute } from '../providers/RouteProvider';
import { useYear } from '../providers/YearProvider';

export type PageTypes =
	| 'state'
	| 'landing'
	| 'national'
	| 'donorNational'
	| 'donorState'
	| 'analysis';

export const useJsonApi = <T,>(
	pageType: PageTypes | undefined,
	customFilterUrl?: string
) => {
	const { selectedState } = useRoute();
	const { year } = useYear();

	const url = useMemo(() => {
		// If a custom filter URL is provided, use it
		if (customFilterUrl) {
			return customFilterUrl;
		}

		if (year !== 2024) return (
			''
		);

		// Otherwise, construct URL based on page type
		if (pageType === 'state') {
			return `/jsonapi/node/data_form?filter[title][condition][path]=title&filter[title][condition][operator]=%3D&filter[title][condition][value]=state_view_${selectedState}&include=field_key_stats,field_state_reference&jsonapi_include=1&filter`;
		} else if (pageType === 'national') {
			return `/jsonapi/node/data_form?filter[title][condition][path]=title&filter[title][condition][operator]=%3D&filter[title][condition][value]=national_view_${selectedState}&include=field_key_stats,field_state_reference&jsonapi_include=1`;
		} else if (pageType === 'donorNational') {
			return `/jsonapi/node/data_form?filter[title][condition][path]=title&filter[title][condition][operator]=%3D&filter[title][condition][value]=donor_gap_national&include=field_key_stats,field_state_reference&jsonapi_include=1`;
		} else if (pageType === 'donorState') {
			return `/jsonapi/node/data_form?filter[title][condition][path]=title&filter[title][condition][operator]=%3D&filter[title][condition][value]=donor_gap_state_${selectedState}&include=field_key_stats,field_state_reference&jsonapi_include=1`;
		} else if (pageType === 'landing') {
			return `/jsonapi/config_pages/2024_women_money_politics_watch`;
		}
		return '';
	}, [selectedState, pageType, year, customFilterUrl]);

	const { isFetching, data } = useFetch<T | null>(
		url,
		document.location.origin.includes('localhost')
			? environmentService.get('VITE_BASE_API_URL')
			: document.location.origin
	);

	return { isFetching, data, state: selectedState };
};
